export default __webpack_public_path__ + "static/media/train600x807.33b6561d.jpg";